import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageHeader } from "./ServiceDetail";
import { GoldButton, Reveal } from "../components/ui-kit";
import { SERVICES, IMAGES } from "../data/content";

export default function Prestations() {
  return (
    <div data-testid="prestations-page">
      <PageHeader overline="Nos prestations" title="La musique et la technique, notre métier" subtitle="Des prestations que KMR Event assure directement, pensées pour être combinées selon votre événement." image={IMAGES.heroBand} />
      <section className="py-12 pb-24">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 space-y-10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.05}>
              <div className={`glass rounded-2xl overflow-hidden grid md:grid-cols-2 ${i % 2 ? "md:[direction:rtl]" : ""}`} data-testid={`prestation-${s.slug}`}>
                <div className="h-72 md:h-auto [direction:ltr]"><img src={s.image} alt={s.title} className="w-full h-full object-cover" /></div>
                <div className="p-8 sm:p-10 [direction:ltr]">
                  <h2 className="font-serif text-3xl text-foreground">{s.title}</h2>
                  <p className="text-gold/80 mt-1">{s.tagline}</p>
                  <p className="mt-4 text-muted-foreground leading-relaxed">{s.short}</p>
                  <ul className="mt-5 space-y-2">
                    {s.benefits.map((b) => <li key={b} className="flex items-center gap-2 text-sm text-foreground/85"><Check size={15} className="text-gold" /> {b}</li>)}
                  </ul>
                  <div className="mt-6 flex gap-4">
                    <Link to={`/${s.slug}`} className="text-gold hover:underline inline-flex items-center gap-1 text-sm">Détails <ArrowRight size={14} /></Link>
                    <Link to="/devis" className="text-sm text-foreground/70 hover:text-gold">Demander un devis</Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="text-center pt-6"><GoldButton to="/devis" data-testid="prestations-devis-btn">Demander un devis <ArrowRight size={16} /></GoldButton></div>
        </div>
      </section>
    </div>
  );
}
